/**
 * Tenant overrides orchestrator.
 *
 * Sets `document.documentElement.dataset.tenant = '<id>'` (CSS scope trigger
 * for `tenants/<id>/styles/*.css`) and delegates to the tenant module for
 * dynamic overrides (i18n, icons …).
 *
 * Called in `app/index.tsx` right after `import './i18n'`.
 */
import { getActiveTenant } from './tenants';
import { applyFamilux } from './familux';

export const applyTenantOverrides = (): void => {
  const tenant = getActiveTenant();
  if (!tenant) return;

  document.documentElement.dataset.tenant = tenant;

  if (tenant === 'familux') {
    applyFamilux();
  }
};
